import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_RELEASE_ENV,
  release: process.env.REACT_APP_APP_VERSION,
});
